export const collectionNames = {
  CLIENTS: "clients",
  STAFF: "staff",
};
